var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnFlagIcon = function SvgEnFlagIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 56 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.84668 -0.173828V32.1788H59.8475V-0.173828H-3.84668Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.84668 -0.173828L59.8475 32.1788L-3.84668 -0.173828ZM59.8475 -0.173828L-3.84668 32.1758L59.8475 -0.173828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4237 35.0719L27.9999 19.6171L-2.42384 35.0719L-5.27051 29.2794L20.8774 15.9993L-5.27051 2.71935L-2.42384 -3.07324L27.9999 12.3816L58.4237 -3.07324L61.2703 2.71935L35.1224 15.9993L61.2703 29.2794L58.4237 35.0719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.84668 -0.173828L59.8475 32.1788L-3.84668 -0.173828ZM59.8475 -0.173828L-3.84668 32.1758L59.8475 -0.173828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8963 34.1059L28.0001 18.4081L-2.89618 34.1059L-4.79785 30.2452L23.2546 15.9992L-4.79785 1.75332L-2.89618 -2.10742L28.0001 13.5904L58.8963 -2.10742L60.798 1.75332L32.7455 15.9992L60.798 30.2452L58.8963 34.1059Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 -0.173828V32.1788V-0.173828ZM-3.84668 16.001H59.8475H-3.84668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3087 32.1758H22.6921V21.3936H-3.84668V10.6084H22.6921V-0.173828H33.3087V10.6084H59.8475V21.3936H33.3087V32.1758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 -0.173828V32.1788V-0.173828ZM-3.84668 16.001H59.8475H-3.84668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1854 32.1758H24.8154V19.2365H-3.84668V12.7654H24.8154V-0.173828H31.1854V12.7654H59.8475V19.2365H31.1854V32.1758Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 32,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnFlagIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en-flag-icon.4361068c.svg";
export { ForwardRef as ReactComponent };